import { useEffect } from 'react'
import { useCurrentOrganization } from '@/features/organization/hooks/useCurrentOrganization'
import { useAuthStore } from '@/stores/useAuthStore'
import { brandLightColor } from '@/lib/brandColor'

const DEFAULT_PRIMARY_COLOR = '#004A6B'
const hexColorRegex = /^#([0-9A-Fa-f]{3}){1,2}$/

function resolvePrimaryColor(value: string | undefined): string {
  return value && hexColorRegex.test(value) ? value : DEFAULT_PRIMARY_COLOR
}

/** The brand colour, plus a lighter variant that stays readable in dark mode. */
function applyBrandColor(color: string): void {
  const root = document.documentElement
  root.style.setProperty('--color-primary', color)
  root.style.setProperty('--color-primary-light', brandLightColor(color))
}

export function OrganizationBrandTheme(): null {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const { data: organization } = useCurrentOrganization()
  const primaryColor = resolvePrimaryColor(organization?.branding?.primaryColor)

  useEffect(() => {
    applyBrandColor(primaryColor)

    return () => {
      applyBrandColor(DEFAULT_PRIMARY_COLOR)
    }
  }, [primaryColor])

  useEffect(() => {
    if (!isAuthenticated) {
      applyBrandColor(DEFAULT_PRIMARY_COLOR)
    }
  }, [isAuthenticated])

  return null
}

OrganizationBrandTheme.displayName = 'OrganizationBrandTheme'
